import { NotificationProgressInfo } from '../../../core/server-notification/progress-notification.interfaces';

interface CalculationProgress {
    notification: NotificationProgressInfo;
}
interface ImportDataProgress {
    notification: NotificationProgressInfo;
}
interface ImportInstrumentsProgress {
    notification: NotificationProgressInfo;
}

export interface IProgressState {
    calculation: CalculationProgress;
    importData: ImportDataProgress;
    importInstruments: ImportInstrumentsProgress;
}

const initialState: IProgressState = {
    calculation: {} as CalculationProgress,
    importData: {} as ImportDataProgress,
    importInstruments: {} as ImportInstrumentsProgress
};

export default initialState;



// WEBPACK FOOTER //
// /home/runner/work/cdg-missioncontrol/cdg-missioncontrol/MissionControlClient2/MissionControl.WebUi2/mc-app/src/app/app-states/modules/progress/IProgressSate.ts